export class ChatItemDisplay {
    chatbotResponse?: string;
    message?: string;

    constructor(chatbotResponse?: string, message?: string) {
        this.chatbotResponse = chatbotResponse;
        this.message = message;
    }
}
